import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import { intents } from './intents';
import type { TSelectBase } from 'types/general.types';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  excludeIntents?: string[];
}

const IntentsCombobox = ({
  isMulti = false,
  onValueChange,
  value,
  disabled = false,
  excludeIntents,
  ...props
}: Props) => {
  const [list, setList] = useState<TSelectBase[]>(intents);

  useEffect(() => {
    if (excludeIntents && excludeIntents.length) {
      const x = intents.filter((intent) => !excludeIntents.includes(intent.value));
      setList(x);
    }
  }, [excludeIntents]);

  return (
    <div {...props}>
      <HubertCombobox
        itemName="intent"
        isMulti={isMulti}
        items={list}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default IntentsCombobox;
